import AboutCompanyTwoItem from "../components/AboutCompanyTwoItem";
import { useTranslation } from "react-i18next";

const AboutCompanyTwoSection = () => {
  const { t } = useTranslation();
  return (
    <section
      id="o-kompanii-two"
      className="w-full h-[700px] lg:h-[1200px] relative bg-[url('/8-min%202.png')] bg-cover bg-center bg-no-repeat"
    >
      <div className="about-company-two-items absolute top-0 left-0 w-full h-full bg-black/50 flex flex-col items-center justify-center">
        <AboutCompanyTwoItem
          title={t("about.stats.yearsTitle")}
          secondaryText={t("about.stats.yearsSubtitle")}
        />
        <AboutCompanyTwoItem
          title={t("about.stats.workersTitle")}
          secondaryText={t("about.stats.workersSubtitle")}
        />
        <AboutCompanyTwoItem
          title={t("about.stats.areaTitle")}
          secondaryText={t("about.stats.areaSubtitle")}
        />
        <AboutCompanyTwoItem
          title={t("about.stats.projectsTitle")}
          secondaryText={t("about.stats.projectsSubtitle")}
        />
      </div>
    </section>
  );
};

export default AboutCompanyTwoSection;

